angular.module('leanlaw').factory('objectNumberManipulator', ['$q', '$rootScope', 'leanLawApi', function ($q, $rootScope, leanLawApi) {
  const requests = {};
  const apiRequests = {};

  // Sum values from source to target
  function sumValues(dataDest, dataSource) {
    if (!dataDest || !dataSource) return;
    const keys = Object.keys(dataSource);
    keys.forEach(k => {
      if (!isNaN(Number(dataSource[k]))) {
        dataDest[k] += dataSource[k];
      } else if (typeof dataSource[k] == "object") {
        sumValues(dataDest[k], dataSource[k]);
      } else {
        // Some other data type
      }
    });

    // Unneccessary. dataDest will have been updated automatically
    return dataDest;
  }

  // Deep set numbers to 0
  function resetValues(obj) {
    if (!obj) return;
    const keys = Object.keys(obj);
    keys.forEach(k => {
      if (!isNaN(Number(obj[k]))) {
        obj[k] = 0.0;
      } else if (typeof obj[k] == "object") {
        resetValues(obj[k]);
      }
    });
  }
  return {
    sumValues,
    resetValues
  };
}]);